export const CONTENT_KEYWORD_FILTER_BY_STATE = [
  { state: /^FL$/i, keywords: [/CCSS/i, /TEKS/i] },
  { state: /^TX$/i, keywords: [/CCSS/i, /FLBEST/i, /FL BEST/i] },
  // For all other states filter out TEKS and FLBEST
  { state: /.*/, keywords: [/TEKS/i, /FLBEST/i, /FL BEST/i] },
];